import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmPopUpFinzyFlexSkeletonData {
    title: string;
    subTitle: string
    positiveButtonText: string;
    negativeButtonText: string;
    image?: string;
}

@Component({
    selector: 'app-confirm-pop-up-finzy-flex-skeleton',
    styleUrls: ['./confirm-pop-up-finzy-flex-skeleton.component.css'],
    templateUrl: './confirm-pop-up-finzy-flex-skeleton.component.html'
})
export class ConfirmPopUpFinzyFlexSkeletonComponent<T> {
    constructor(
        public dialogRef: MatDialogRef<T>,
        @Inject(MAT_DIALOG_DATA) public readonly popUpData: ConfirmPopUpFinzyFlexSkeletonData) {
    }

    decline(): void {
        this.dialogRef.close();
    }
}